import React from 'react';
import classes from "./ProcessTitle.module.css";

export default function ProcessTitle() {
  return (
    <div className={classes.Title}>
        <h2>HOW THE PROCESS</h2>
    </div>
  )
}
